import { Box } from '@dtx-company/shared-components/src/components/atoms/Box/index'
import { FC } from 'react'
import { Text } from '@dtx-company/shared-components/src/components/atoms/Text/index'
import { theme } from '@dtx-company/shared-components/src'
import styled from 'styled-components'

const Line = styled.div<{ vertical?: boolean }>`
  ${({ vertical }) =>
    vertical
      ? `
    border-right: 1px solid ${theme.colors.secondary.border};
    height: 100%;
    width: 1px;
  `
      : `
    border-top: 1px solid ${theme.colors.secondary.border};
    height: 1px;
    width: 100%;
  `}
`
const TextRotated = styled(Text)<{ vertical?: boolean }>`
  ${({ vertical }) =>
    vertical
      ? `
    transform: rotate(-90deg);
    margin: 12px 0;
  `
      : `
    margin: 0 12px;
  `}
`
export const TextDivider: FC<{ vertical?: boolean; copy: string }> = ({ vertical, copy }) => (
  <Box
    alignItems="center"
    flexDirection={vertical ? 'column' : 'row'}
    margin={vertical ? '0 24px' : '24px 0'}
    padding={vertical ? '12px 0' : '0 12px'}
  >
    <Line vertical={vertical} />
    <TextRotated vertical={vertical} color="primary.grey" fontSize="12px">
      {copy}
    </TextRotated>
    <Line vertical={vertical} />
  </Box>
)

export const STRIPE_STYLES = {
  base: {
    fontSize: '16px',
    color: '#424770',
    '::placeholder': {
      color: '#888'
    }
  },
  invalid: {
    color: '#9e2146'
  }
}
